import { useMutation } from '@tanstack/react-query'

import { createCheckoutSession } from 'src/services/subscriptionApi'

export const useCreateCheckoutMutation = () => {
  return useMutation({
    mutationFn: ({
      priceId,
      promoCode,
    }: {
      priceId: string
      promoCode?: string
    }) => createCheckoutSession(priceId, promoCode),
  })
}
